import React from 'react';
import styles from '../ScrapeSetting/styles';
import AvailHistoryContent from '../ScrapeSetting/AvailHistory';

export default () => {
  const cls = styles();

  return (
    <div id="inventoryEmpty" className={cls.content}>
      <div className={cls.cardHeader}>
        <span className={cls.title}>Appointment Check History</span>
      </div>

      <AvailHistoryContent />
    </div>
  );
};